import Vue from 'vue'

// import '../node_modules/@fortawesomei/fontawesome-pro/css/all.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas, far, fal, fab)

// require('@fortawesome/fontawesome-pro/css/all.css');
// require('@fortawesome/fontawesome-pro/js/all.js');


Vue.component('fai', FontAwesomeIcon)
